module.exports = {"522730001":"冠山街道","522730100":"龙山镇","522730102":"醒狮镇","522730103":"谷脚镇","522730104":"湾滩河镇","522730105":"洗马镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/522730.json
// module id = 2347
// module chunks = 0